<ol class="breadcrumb page-breadcrumb">
  <li class="breadcrumb-item">
    <a href="javascript:void(0);" [routerLink]="['/admin/home']">Home</a>
  </li>
  <li class="breadcrumb-item active">Disponibilidades do Teacher</li>
  <li class="position-absolute pos-top pos-right d-none d-sm-block">
    <span class="js-get-date"></span>
  </li>
</ol>

<div id="panel-2" class="panel">
  <div class="panel-hdr bg-primary-600 bg-primary-gradient">
    <h2>
      Disponibilidades do <span class="fw-300"><i>Teacher</i></span>
    </h2>
    <div class="panel-toolbar">
      <a
        href="javascript:void(0);"
        class="btn btn-success btn-sm btn-icon rounded-circle waves-effect waves-themed mr-2"
        data-action="panel-collapse"
        data-toggle="tooltip"
        data-offset="0,10"
        data-original-title="Collapse"
      >
        <i class="fal fa-minus text-white fw-900"></i>
      </a>
      <a
        href="javascript:void(0);"
        class="btn btn-warning btn-sm btn-icon rounded-circle waves-effect waves-themed mr-2"
        data-action="panel-collapse"
        data-toggle="tooltip"
        data-offset="0,10"
        data-original-title="Fullscreen"
      >
        <i class="fal fa-expand text-primary fw-900"></i>
      </a>
      <a
        href="javascript:void(0);"
        class="btn btn-danger btn-sm btn-icon rounded-circle waves-effect waves-themed"
        data-action="panel-collapse"
        data-toggle="tooltip"
        data-offset="0,10"
        data-original-title="Close"
      >
        <i class="fal fa-times text-white fw-900"></i>
      </a>
    </div>
  </div>
  <div class="panel-container show">
    <div class="panel-content">
      <div class="row">
        <div class="col-12">
          <div class="alert alert-primary alert-dismissible">
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">
                <i class="fal fa-times"></i>
              </span>
            </button>
            <div class="d-flex flex-start w-100">
              <div class="mr-2 d-sm-none d-md-block">
                <span class="icon-stack icon-stack-lg">
                  <i
                    class="base base-6 icon-stack-3x opacity-100 color-primary-500"
                  ></i>
                  <i
                    class="base base-10 icon-stack-2x opacity-100 color-primary-300 fa-flip-vertical"
                  ></i>
                  <i
                    class="fal fa-info icon-stack-1x opacity-100 color-white"
                  ></i>
                </span>
              </div>
              <div class="d-flex flex-fill">
                <div class="flex-fill">
                  <div class="row">
                    <div class="col-9">
                      <span class="h5">Informações</span>
                      <p class="mb-0">
                        Selecione os horários que o(a) teacher estará disponível
                        para aulas.
                      </p>
                      <p class="mb-0">
                        Esses horários ficarão visíveis nos locais públicos.
                      </p>
                    </div>
                    <div class="col-3">
                      <span class="h5">Legenda & Cores</span>
                      <div class="panel-toolbar d-block">
                        <div class="row mt-2">
                          <div class="col">
                            <a
                              href="javascript:void(0);"
                              class="btn btn-success btn-sm btn-icon rounded-circle waves-effect waves-themed mr-2"
                              data-toggle="tooltip"
                              data-offset="0,10"
                              data-original-title="Collapse"
                            >
                              <i class="fal text-success fw-900"></i>
                            </a>
                            Disponível
                          </div>
                          <div class="col">
                            <a
                              href="javascript:void(0);"
                              class="btn btn-light btn-sm btn-icon rounded-circle waves-effect waves-themed mr-2"
                              data-toggle="tooltip"
                              data-offset="0,10"
                              data-original-title="Fullscreen"
                            >
                              <i class="fal text-light fw-900"></i>
                            </a>
                            Livre
                          </div>
                          <div class="col">
                            <a
                              href="javascript:void(0);"
                              class="btn btn-danger btn-sm btn-icon rounded-circle waves-effect waves-themed"
                              data-toggle="tooltip"
                              data-offset="0,10"
                              data-original-title="Close"
                            >
                              <i class="fal text-danger fw-900"></i>
                            </a>
                            Ocupado
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <span
            role="status"
            aria-hidden="true"
            class="spinner-border spinner-border-sm pull-left mr-2 text-primary"
            *ngIf="flagSearchTeacher"
          ></span>
          <span class="text-primary pull-left" *ngIf="flagSearchTeacher"
            >Carregando teachers</span
          >
          <label class="form-label" for="teacherId"
            >Teacher <span class="text-danger">*</span>
          </label>
          <div class="input-group-append">
            <div class="ng-autocomplete">
              <ng-autocomplete
                [data]="teacherDataList"
                searchKeyword="name"
                placeholder="Selecione o teacher"
                (selected)="selectEvent($event)"
                (inputChanged)="onChangeSearch($event)"
                (inputFocused)="onFocused($event)"
                [itemTemplate]="itemTemplate"
                [notFoundTemplate]="notFoundTemplate"
              >
              </ng-autocomplete>

              <ng-template #itemTemplate let-item>
                <a [innerHTML]="item.name"></a>
              </ng-template>

              <ng-template #notFoundTemplate let-notFound>
                <div [innerHTML]="notFound"></div>
              </ng-template>
            </div>
            <button
              class="btn btn-primary ml-2"
              type="button"
              [disabled]="flagFiltering"
              (click)="getCalendarByTeacher()"
            >
              <span
                *ngIf="flagFiltering"
                class="spinner-border spinner-border-sm mr-1"
              ></span>
              Filtrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-content" *ngIf="!showData">
      <div class="row">
        <div class="col-12">
          <div class="alert alert-warning" role="alert">
            {{ returnMessage }}
          </div>
        </div>
      </div>
    </div>
    <div class="panel-content" *ngIf="showData">
      <div class="row">
        <div class="col-12">
          <div class="table-responsive-lg">
            <table class="table table-bordered m-0">
              <thead class="thead-dark">
                <tr>
                  <th
                    *ngFor="let day of daysOfWeekDataList$ | async"
                    class="text-center"
                  >
                    {{ day.text }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let hour of hoursOfDay">
                  <th
                    *ngFor="let day of daysOfWeekDataList$ | async"
                    class="text-center fw-700 check-time"
                    (click)="setTeacherAvailability(day.id, hour)"
                    [ngClass]="{
                      'alert bg-danger text-white':
                        checkAvailability(day.id, hour) === 'busy',
                      'alert bg-success text-white':
                        checkAvailability(day.id, hour) === 'free',
                      'alert bg-transparent text-secondary':
                        checkAvailability(day.id, hour) === 'none'
                    }"
                  >
                    {{ hour }}
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-12">
          <div
            class="alert alert-warning alert-dismissible text-left fade show mt-3"
            role="alert"
            *ngIf="!validAvailability"
          >
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true"><i class="fal fa-times"></i></span>
            </button>
            {{ errorMessage }}
          </div>
          <div
            *ngIf="listErrorMessage && !validAvailability"
            class="invalid-feedback"
          >
            <div *ngFor="let error of listErrorMessage">{{ error }}</div>
          </div>
        </div>
        <div class="col-12">
          <div
            class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-center justify-content-end mt-3"
          >
            <button
              class="btn btn-sm btn-info mr-1 waves-effect waves-themed"
              type="button"
              (click)="cleanAvailability()"
            >
              <i class="fa fa-eraser mr-1"></i> Limpar disponibilidade
            </button>
            <button
              class="btn btn-sm btn-secondary mr-1 waves-effect waves-themed"
              type="button"
              data-dismiss="modal"
              (click)="cancel()"
            >
              <i class="fa fa-times-circle mr-1"></i> Cancelar
            </button>
            <button
              class="btn btn-sm btn-primary waves-effect waves-themed"
              type="button"
              (click)="done()"
            >
              <i class="fa fa-check mr-1"></i> Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
